<div id="generate-course-form-pdf" class="text-center d-none">

    <h3>Seleccionar documento PDF</h3>

    <p>Para generar un curso desde un documento PDF, puede subir un archivo o usar un archivo previamente subido.</p>
    <p>Una vez que seleccione el documento a usar, se deberá revisar el documento para extraer su estructura y determinar si es posible generar un curso. Si no es posible extraer una estructura, deberá proveerla.</p>

    <div id="pdf-upload-form" *ngIf="!selectedPdf">
        <div id="pdf-upload-div" class="mb-3">
            <label for="pdf-upload">
                <span class="fw-bold">Subir un archivo nuevo:</span>
                <input id="pdf-upload" type="file" name="pdf[]" class="btn btn-primary" (change)="pdfUpload($event)">
                <div id="pdf-upload-spinner" class="mt-3 mb-3" *ngIf="uploadingPdf">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Subiendo...</span>
                </div>
                <div id="pdf-upload-error" class="red mt-3 mb-3" *ngIf="uploadPdfError">
                    <i class="fa fa-times"></i>
                    <span>Ha habido un error.</span>
                </div>
            </label>
        </div>
        <div id="pdf-files-div" class="mt-3">
            <label for="pdf-files">
                <span class="fw-bold">o seleccione un archivo ya subido:</span>
                <select name="pdf-files" id="pdf-files" (change)="changeSelectedPdf($event)">
                    <option disabled selected value="-1">Seleccione un PDF...</option>
                    <option *ngFor="let pdf of existingPdfs" [ngValue]="pdf" [attr.selected]="selectedPdf === pdf ? 'selected' : null">{{ pdf }}</option>
                </select>
            </label>
        </div>
    </div>

    <div id="selected-pdf" *ngIf="selectedPdf && !generateLoading && !generateSuccess">
        <p><span class="fw-bold">PDF seleccionado:</span> {{ selectedPdf }}</p>
        <button class="btn btn-primary me-2" (click)="openPdf()">
            <i class="fa fa-file-pdf"></i>
            <span>Ver archivo seleccionado</span>
        </button>
        <button class="btn btn-primary ms-2" (click)="selectedPdf = ''">
            <i class="fa fa-file-pdf"></i>
            <span>Cambiar</span>
        </button>
    </div>

    <div id="pdf-verifytoc" class="mt-3 mb-3" *ngIf="selectedPdf && !generateLoading && !generateSuccess">
        <p class="fw-bold">Extracción índice PDF</p>
        <p>Antes de generar un curso con el documento PDF, debemos extraer su estructura para generar un índice para el curso.</p>
        
        <div id="pdf-verifytoc-embeddedindex">
            <label for="pdf-verifytoc-embeddedindex-input">
                <span class="me-3">¿El documento PDF tiene índice incrustado? (El índice se encuentra en las páginas del documento)</span>
                <input type="checkbox" id="pdf-verifytoc-embeddedindex-input" [(ngModel)]="pdfEmbeddedIndex" (ngModelChange)="changeEmbeddedIndex()" [attr.disabled]="verifyLoading ? 'disabled' : null">
            </label>
        </div>

        <div id="pdf-verifytoc-indexpages" class="mt-3 mb-3" *ngIf="pdfEmbeddedIndex">
            <p>Para mejores resultados, por favor indique los números de página donde inicia y termina el índice del PDF.</p>
            <label for="pdf-index-start">
                <span class="fw-bold">Página inicial del índice:</span>
                <input type="number" min="1" id="pdf-index-start" size="3" [(ngModel)]="pdfIndexStart" [attr.disabled]="verifyLoading ? 'disabled' : null">
            </label>
            <label for="pdf-index-end">
                <span class="fw-bold">Página final del índice:</span>
                <input type="number" min="1" id="pdf-index-end" size="3" [(ngModel)]="pdfIndexEnd" [attr.disabled]="verifyLoading ? 'disabled' : null">
            </label>
        </div>

        <div id="pdf-verifytoc-start" class="mt-3 mb-3">
            <p>Una vez seleccionados los parámetros, pulse este botón para iniciar la extracción.</p>
            <button id="verifytoc" class="btn btn-primary" (click)="verifyToc()" [attr.disabled]="verifyLoading ? 'disabled' : null">
                <i class="fa fa-file-pdf"></i>
                <span>Extraer estructura PDF</span>
            </button>
        </div>
    
        <div id="pdf-verifytoc-status" class="mt-3 mb-3">
            <div id="pdf-verifytoc-spinner" *ngIf="verifyLoading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Procesando, espere por favor...</span>
            </div>
            <div id="pdf-verifytoc-error" *ngIf="verifyError">
                <p class="fw-bold">Resultado:</p>
                <p class="red">
                    <i class="fa fa-times"></i>
                    <span>Lo sentimos, no se ha podido extraer la estructura.</span>
                </p>
                <p class="red">{{ verifyMessage }}</p>
                <p>Si desea generar un curso con este PDF, deberá crear la estructura del curso deseado.</p>
                <p>Puede usar el editor de estructura más abajo en esta página para crear una estructura. Una vez que la estructura del curso esté lista, puede crear el curso.</p>
            </div>
            <div id="pdf-verifytoc-success" *ngIf="verifySuccess">
                <p class="fw-bold">Resultado:</p>
                <div class="text-success">
                    <p> 
                        <i class="fa fa-check"></i>
                        <span class="fw-bold">Se ha extraído la estructura correctamente.</span>
                    </p>
                    <p class="fw-bold">Mensaje del generador:</p>
                    <p class="text-decoration-underline">{{ verifyMessage }}</p>
                </div>
            </div>
        </div>
    </div>
    
    <div id="pdf-verifytoc-tree" class="mt-3 mb-3" *ngIf="selectedPdf && !verifyLoading && (verifySuccess || verifyError) && !generateLoading && !generateSuccess">
        <details id="toc-tree-suggestions" class="mt-3 mb-3">
            <summary class="fw-bold">Sugerencias para obtener los mejores resultados</summary>
            <div>
                <p>Los documentos PDF que dan mejores resultados son aquellos que tienen una tabla de contenidos (TOC por sus siglas en inglés). Usualmente, esta tabla de contenidos aparecerá en la parte izquierda del visor de PDF. Éste es el mejor caso posible, ya que la estructura del curso será muy parecida a la tabla de contenidos.</p>
                <p>Si un PDF no tiene esta tabla, se usa el índice dentro de las páginas del PDF. En ese caso, recomendamos seleccionar la opción "Índice incrustado" y especificar las páginas de inicio y fin del índice.</p>
                <p>Si un PDF carece de tabla de contenidos y de páginas de índice, se usarán los tamaños de las fuentes para determinar unidades y lecciones. Éste es el peor caso posible.</p>
                <p>Por tanto, para obtener los mejores resultados posibles, le recomendamos editar el PDF y agregar una tabla de contenidos, ya sea con un editor de documentos PDF, o convirtiéndolo a Word, editándolo, y exportándolo a PDF.</p>
            </div>
            <hr>
            <div>
                <p>Si ha extraído la estructura del PDF y no ha dado el resultado esperado, intente usar la opción no seleccionada.</p>
                <p>Por ejemplo, si ha seleccionado la opción de "Índice incrustado" y ha especificado los números de inicio y fin del índice, y no ha obtenido un resultado satisfactorio, intente extraer la estructura deseleccionando esta opción.</p>
                <p>Inversamente, si no ha seleccionado la opción de "Índice incrustado", intente extraer la estructura seleccionando esta opción y especificando los números de inicio y fin del índice.</p>
            </div>
            <hr>
            <div>
                <p>Ya sea que se haya logrado extraer la estructura o se ha creado desde cero, le recomendamos que la estructura del curso sea lo más parecida posible a los títulos de los contenidos. Esto pasa porque a veces los nombres de los capítulos en el índice del PDF no coinciden con el encabezado del capítulo.</p>
                <p>Por ejemplo, si en el índice aparece "Capítulo 1: Introducción", y en el encabezado del capítulo en sí aparece algo diferente (p.ej.: "Capítulo 1: Introducción a X"), recomendamos que esa unidad tenga como nombre el encabezado del capítulo en sí.</p>
            </div> 
        </details>
        
        <details id="reset-units" class="mt-3 mb-3">
            <summary class="fw-bold">Vaciar la estructura existente y volver a empezar</summary>
            <p>Si desea descartar la estructura propuesta y construir su propia estructura para el curso, pulse este botón.</p>
            <button class="btn btn-primary" (click)="emptyUnits()">
                <i class="fa fa-trash"></i>
                <span>Vaciar</span>
            </button>
        </details>

        <details id="toc-tree-instructions" class="mt-3 mb-3">
            <summary class="fw-bold">Instrucciones rápidas para el editor de estructura</summary>
            <div>
                <p class="text-decoration-underline">Para añadir una unidad:</p>
                <p>Clic derecho sobre una unidad y hacer clic en "Añadir unidad". Escriba el nombre de la unidad y pulse Enter para añadirla.</p>
            </div>
            <div>
                <p class="text-decoration-underline">Para añadir una lección:</p>
                <p>Clic derecho sobre una unidad y hacer clic en "Añadir lección". Escriba el nombre de la lección y pulse Enter para añadirla.</p>
            </div>
            <div>
                <p class="text-decoration-underline">Para cambiar el nombre de una unidad o lección:</p>
                <p>Clic derecho sobre una unidad o lección y hacer clic en "Editar". Se seleccionará el nombre de la unidad, cámbielo y presione Enter para guardar los cambios.</p>
            </div>
            <div>
                <p class="text-decoration-underline">Para borrar una unidad o lección:</p>
                <p>Clic derecho sobre una unidad o lección y hacer clic en "Borrar". También puedes seleccionar una o varias y presionar Supr.</p>
            </div>
        </details>

        <details id="toc-tree-advanced-tools" class="mt-3 mb-3">
            <summary class="fw-bold">Herramientas avanzadas (para desarrolladores)</summary>
            <button class="btn btn-primary me-3" onclick="document.getElementById('json-upload').click()">
                <i class="fa fa-file-import"></i>
                <!-- 
                <i class="fa fa-file"></i>
                <i class="fa fa-arrow-right"></i>
                <i class="far fa-folder-tree"></i>
                -->
                <span>Importar estructura (JSON)</span>
            </button>
            <input id="json-upload" type="file" name="json[]" class="btn btn-primary d-none" (change)="importUnits($event)">
            <button class="btn btn-primary ms-3" (click)="exportUnits()">
                <i class="fa fa-file-export"></i>
                <!--
                <i class="far fa-folder-tree"></i>
                <i class="fa fa-arrow-right"></i>
                <i class="fa fa-file"></i>
                -->
                <span>Exportar estructura (JSON)</span>
            </button>
        </details>

        <div id="course-toc-tree">
            <p class="text-center"><strong>Editor de estructura</strong></p>
            <div id="pdf-jstree"></div>
        </div>
    </div>

    <div id="pdf-verifytoc-tables" *ngIf="selectedPdf && !verifyLoading && (verifySuccess || verifyError) && !generateLoading && !generateSuccess">
        <div id="pdf-verifytoc-tables-check" class="mt-3 mb-3">
            <p class="fw-bold">Extracción de tablas</p>
            <label for="pdf-extract-tables">
                <span>¿Desea extraer tablas del documento?</span>
                <input class="ms-3" type="checkbox" id="pdf-extract-tables" [(ngModel)]="pdfExtractTables">
            </label>
        </div>
        <div id="pdf-verifytoc-tables-borderwidth" class="mt-3 mb-3" *ngIf="pdfExtractTables">
            <p class="fw-bold">Grosor de los bordes:</p>
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                
                <label class="btn btn-primary" [ngClass]="{'active' : pdfTableBorders === 'fino'}">
                    <input type="radio" name="options" id="option1" autocomplete="off" (click)="pdfTableBorders = 'fino'">
                    <span class="mb-3">Fino</span>
                    <table id="border-thin">
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </label>
    
                <label class="btn btn-primary" [ngClass]="{'active' : pdfTableBorders === 'normal'}">
                    <input type="radio" name="options" id="option2" autocomplete="off" (click)="pdfTableBorders = 'normal'">
                    <span class="mb-3">Normal</span>
                    <table id="border-normal">
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </label>
    
                <label class="btn btn-primary" [ngClass]="{'active' : pdfTableBorders === 'grueso'}">
                    <input type="radio" name="options" id="option3" autocomplete="off" (click)="pdfTableBorders = 'grueso'">
                    <span class="mb-3">Grueso</span>
                    <table id="border-thick">
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </label>
            </div>
        </div>
    </div>
        
    <div id="pdf-toc-generate-status" class="mt-3">
        <div id="pdf-toc-generate-spinner" *ngIf="generateLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="pdf-toc-generate-error" class="text-danger" *ngIf="generateError">
            <p>
                <i class="fa fa-times"></i>
                <span>El curso no se ha podido generar. Por favor, inténtelo con otro documento.</span>
            </p>
            <span>{{ generateMessage }}</span>
        </div>
        <div id="pdf-toc-generate-success" class="text-success" *ngIf="generateSuccess">
            <p>
                <i class="fa fa-check"></i>
                <span class="fw-bold">Se ha generado el curso correctamente.</span>
            </p>
            <p class="fw-bold">Mensaje del generador:</p>
            <p class="text-decoration-underline">{{ generateMessage }}</p>
        </div>
    </div>

    <div id="pdf-verifytoc-buttons" class="my-3">
        <button class="btn btn-primary" data-direction="back" data-parent="pdf" data-prev="source" (click)="move($event)" *ngIf="!generateSuccess">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success" (click)="generateCoursePdfToc()" *ngIf="!generateSuccess" [attr.disabled]="!generateLoading && !generateSuccess && !verifyLoading && units.length > 0 && (verifySuccess || verifyError) ? null : 'disabled'">
            <i class="fa fa-book"></i>
            <span>Generar curso</span>
        </button>
        <button class="btn btn-success" *ngIf="generateSuccess" routerLink="/course/{{ newCourseID }}" routerLinkActive="active">
            <i class="fa fa-book"></i>
            <span>Ir al curso</span>
        </button>
    </div>

</div>